import React from "react";
import * as cl from "./CourseProgress.module.scss";
import CircleProgressBar from "../CircleProgressBar/CircleProgressBar";
import CheckSVG from "../SVG/CheckSVG";

const CourseProgress = ({
  list,
  currentBlockName,
  changeSelect,
  progressInPercent,
}) => {
  const progressList = Object.values(list);

  return (
    <ul className={cl.wrapper}>
      {/*<i className={cl._check}><CheckSVG/></i> <span className={cl._done}>DONE</span>*/}
      {/*<CircleProgressBar strokeWidth={3} sqSize={16} total={22}/> <span className={cl._in_progress}>IN PROGRESS</span>*/}
      {/*<i/> <span>EMPTY</span>*/}

      {progressList.map((item, index) => {
        const isCurrent = item.title === currentBlockName;
        const isDone = progressInPercent[index] === 100;
        const isEmpty = progressInPercent[index] === 0;
        const textStyle = isCurrent ? cl._in_progress : isDone ? cl._done : "";
        // const isDone = item.progress === true

        return (
          <li
            className={cl.item}
            key={index}
            onClick={() => changeSelect(item.title)}
          >
            {/*<button onClick={() => changeSelect(item.title)}>*/}
            {isDone ? (
              <i className={cl._check}>
                <CheckSVG />
              </i>
            ) : isEmpty ? (
              <i />
            ) : (
              <CircleProgressBar
                strokeWidth={3}
                sqSize={16}
                total={progressInPercent[index]}
              />
            )}

            <span className={textStyle}>
              {item.title}
              <p style={{margin: '0 0 0 15px', fontSize: '13px'}} className={textStyle}>{item.credit_label}</p>
            </span>
            {/*</button>*/}
          </li>
        );
      })}
    </ul>
  );
};

export default CourseProgress;
